module.exports = __webpack_public_path__ + "static/media/logo.406d23f8.png";